module.exports = __webpack_public_path__ + "static/media/10-6.ce591ee2.mp3";